$(document).ready(function(){
  console.log(shappify_customer_tags);
  
  if(!shappify_customer_tags.includes('cirefusion')){
    $('#shopify-section-1562003467862').hide();
  }
  
  //IF LOGGING INTO HOMEPAGE
  if($('body').hasClass('customers-login')){
    //$('#create_customer').parent().hide();
    //$('#customer_login').parent().parent().attr('class', 'four columns offset-by-six');
    $('#customer_login, #customer_login h4').css('text-align','center');
    $('#forgot_password').remove();
    var forgotPassword = '<span id="forgot_password"><em><a href="#" onclick="showRecoverPasswordForm()">Forgot your password?</a></em></span>';
  	$('#customer_password').css('margin-bottom', '0');
    $('#customer_password').after(forgotPassword);
    $('.btn[value="Sign In"]').css('margin-top','15px');
  }
  //IF ACCOUNT PAGE
  if($('body').hasClass('customers-account')){
    
    //fix pagination for order history
    if(window.location.href.indexOf('&type=order-history') != -1){
      $('div[data-account-id="order-history"]').show();
      $('a[data-account-id]').each(function(){
          $(this).removeClass('active');
      });
      $('a[data-account-id="order-history"]').addClass('active');
    }
    
    
    $('div[data-account-id="'+ $('a[data-account-id].active').attr('data-account-id') +'"]').show();
    $('.account-options a').click(function(){
      $('a[data-account-id]').each(function(){
          $(this).removeClass('active');
      });
      $(this).addClass('active');
      var showAccountDetails = $(this).attr('data-account-id');
      if(showAccountDetails == 'customer-info'){
        window.location.href = window.location.pathname;
      }
      $('div[data-account-id]').each(function(){
          $(this).hide();
      });
     
      $('div[data-account-id="'+showAccountDetails +'"]').show();
  	});
    
    $('div[data-account-id="order-history"] .paginate a').each(function(){
      if(window.location.href.indexOf('&type=order-history') ==-1 ){
    	$(this).attr('href', $(this).attr('href') + '&type=order-history');
      }
    });
    $('.paginate a').on('click', function(){
   
    });
  }
  //IF PDP
  if($('body').hasClass('product')){
    if($('.shopify-product-reviews-badge').attr('data-id') == 1947599994943 ||
       $('.shopify-product-reviews-badge').attr('data-id') == 1877234221119){
      $('.description p').css('color', '#e10e49');
    }
    $('input[type="number"]').on('keydown', function(e){
      var keycode = e.which;
      if(e.which == 13){
        //console.log('test');
        e.preventDefault();
        return false;
      }
      console.log(keycode);
      
      if (!(event.shiftKey == false && (keycode == 46 || keycode == 8 || keycode == 37 || keycode == 39 || (keycode >= 48 && keycode <= 57) ))) {
        if(keycode > 95 && keycode < 106){
          
        }else{
          event.preventDefault();
          return false;}
      }
    });
  }
});